import React from "react";
import NoFound from "../../Assets/Icons/noData.gif";

const NoData = ({ title }) => {
  return (
    <div className="no-data-gif">
      <img src={NoFound} alt="" />
      <p>{title}</p>
    </div>
  );
};

export default NoData;
